import React, { useState, useMemo, useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import OfferFinancialServicesSummary from './OfferFinancialServicesSummary';
import OfferFinancialServicesListComponent from './OfferFinancialServicesListComponent';
import EuroSymbol from '@mui/icons-material/EuroSymbol';
import { RightsContext } from 'providers/RightsContext';
import CollapseOrBlankCard from 'components/common/CollapseOrBlankCard';

export const OfferFinancialServicesCard = ({
  t,
  document,
  wheelSizes,
  validationInfo,
  saving,
  isDirty,
  onServiceSelectionChange,
  onHeaderPropertyChange,
  onSave,
  servicesLoading,
  onServiceItemPropertyChange,
  onServiceItemComputeValue,
  editable,
  handleModifyData
}) => {
  const { financialServicesWrite } = useContext(RightsContext);
  const [state, setState] = useState({
    expanded: false,
    prevSaving: false
  });

  if (saving !== state.prevSaving) {
    setState({
      prevSaving: saving,
      expanded: !saving && !isDirty ? false : state.expanded
    });
  }

  const toggleExpanded = useCallback(() => {
    setState(prev => ({ ...prev, expanded: !prev.expanded }));
  }, []);

  const getHeaderItems = document => {
    if (document && document.services && document.categoryServices) {
      let itemsFromServices = document.services
        .filter(a => a.selected)
        .map(a => ({
          id: a.serviceTypeId,
          name: a.name,
          serviceMonthlyAmount: a.serviceMonthlyAmount,
          errorMessage: a.errorMessage
        }));
      let itemsFromCategories = document.categoryServices
        .filter(a => a.isSelected)
        .map(a => ({ id: a.serviceCategoryId, name: a.name, serviceMonthlyAmount: a.serviceMonthlyAmount }));
      let items = itemsFromServices.concat(itemsFromCategories);

      return items;
    }
  };

  const headerItems = useMemo(() => getHeaderItems(document), [document]);

  return (
    <CollapseOrBlankCard
      id={'offerFinancialServicesCard'}
      icon={EuroSymbol}
      expanded={document?.services?.length === 0 && !financialServicesWrite ? false : state.expanded}
      canExpand={true}
      onToggle={toggleExpanded}
      title={t('OfferEdit.FinancialServices.Title')}
      subheader={
        <OfferFinancialServicesSummary items={headerItems} currencyCode={document.header.currencyCode} allServices={document?.services} />
      }
      hideSubheaderOnExpand
    >
      <OfferFinancialServicesListComponent
        document={document}
        wheelSizes={wheelSizes}
        validationInfo={validationInfo}
        onServiceSelectionChange={onServiceSelectionChange}
        onHeaderPropertyChange={onHeaderPropertyChange}
        onSave={onSave}
        saving={saving}
        isDirty={isDirty}
        servicesLoading={servicesLoading}
        onServiceItemPropertyChange={onServiceItemPropertyChange}
        onServiceItemComputeValue={onServiceItemComputeValue}
        editable={editable}
        handleModifyData={handleModifyData}
        currencyCode={document.header.currencyCode}
      />
    </CollapseOrBlankCard>
  );
};

OfferFinancialServicesCard.propTypes = {
  t: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isDirty: PropTypes.bool.isRequired,
  document: PropTypes.object.isRequired,
  wheelSizes: PropTypes.array.isRequired,
  validationInfo: PropTypes.object.isRequired,
  saving: PropTypes.bool.isRequired,
  onServiceSelectionChange: PropTypes.func.isRequired,
  onHeaderPropertyChange: PropTypes.func.isRequired,
  servicesLoading: PropTypes.array.isRequired,
  onServiceItemPropertyChange: PropTypes.func.isRequired,
  onServiceItemComputeValue: PropTypes.func.isRequired,
  editable: PropTypes.bool.isRequired,
  handleModifyData: PropTypes.func.isRequired
};

export default withTranslation()(OfferFinancialServicesCard);
